import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/propertyproject/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-staff/propertyproject/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/propertyproject/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  url: '/api/mcc-staff/propertyproject/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/propertyproject/remove',
  method: 'post',
  params: {
    ids,
  },
})
export default {
  getList,
  add,
  detail,
  update,
  remove,
}
